import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import dynamic from 'next/dynamic';
import { useState } from 'react';

const HoverQuickView = dynamic(() => import('@/components/hover-quick-view'), {
  ssr: false,
  loading: () => (
    <div className='fixed left-0 top-0 z-[9999999] flex h-full w-full items-center justify-center bg-white/40'>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='61'
        height='47'
        fill='none'
        viewBox='0 0 61 47'
        className='h-auto w-[100px] animate-pulse'
      >
        <path
          fill='#2F6132'
          d='M58.933 14.594a24 24 0 0 0-2.107-3.893 23 23 0 0 0-2.79-3.385 22.6 22.6 0 0 0-3.386-2.79 22 22 0 0 0-3.892-2.108A22.7 22.7 0 0 0 37.84.613c-3.093 0-6.088.605-8.908 1.795a24 24 0 0 0-3.892 2.108 23 23 0 0 0-3.386 2.79 22.6 22.6 0 0 0-2.79 3.385 22 22 0 0 0-2.107 3.893 22.8 22.8 0 0 0-1.795 8.907c0 2.937.546 5.796 1.629 8.488a70 70 0 0 1-4.556 4.303c-.02.02-.04.029-.059.048-.224.196-.458.39-.692.586a59 59 0 0 1-4.342 3.297 41 41 0 0 1-2.254 1.464c-1.297.79-2.068 1.17-2.097 1.18-.527.264-1.873.77-1.873.77s.468.976 1.639 1.191q.131.03.263.03c.176 0 .332-.02.478-.05a1 1 0 0 0 .351-.097c.01 0 .02-.01.05-.02.282-.116.516-.263.78-.41.77-.419 2.049-1.17 3.668-2.272v-.01a66 66 0 0 0 4.595-3.473c.137-.117.273-.225.4-.342 2.995.537 5.668.83 8.098.868.292.322.605.635.917.937.341.459.77.849 1.278 1.142.293.243.595.487.907.712a22.7 22.7 0 0 0 4.107 2.449 22.7 22.7 0 0 0 4.605 1.56c1.63.361 3.308.547 4.986.547 3.092 0 6.087-.605 8.907-1.795a24 24 0 0 0 3.893-2.108 23 23 0 0 0 3.385-2.79 22.6 22.6 0 0 0 2.79-3.385 22 22 0 0 0 2.108-3.893 22.8 22.8 0 0 0 1.795-8.907c0-3.083-.586-6.088-1.786-8.917m-40.848 18.76c.087-.087.165-.175.253-.263.137-.087.244-.205.322-.331.488-.517.976-1.054 1.454-1.59 6.566-7.396 10.049-11.181 12.41-13.503 2.448-2.4 3.658-3.19 5.229-4.107.683-.4 1.6-.703 2.585-.869a10 10 0 0 1 3.142 0c1.912.322 3.56 1.24 4.605 1.961.36.244.692.566.985.898-.02 0-.04.01-.059.01-.634.097-1.853.4-2.907 1.424-1.424 1.395-2.088 3.337-2.283 6.722-.175 3.093-1.102 5.483-1.844 6.937-1.356 2.673-3.414 4.878-6.117 6.575-.849.537-2.156 1.298-3.63 1.785a19.3 19.3 0 0 1-3.482.761c-1.346.166-2.556.157-3.493-.01a2.9 2.9 0 0 1-.858-.292 24 24 0 0 1-.546-.478 22.7 22.7 0 0 0 4.126-.634c1.61-.41 3.054-1.005 4.293-1.776 2.058-1.278 3.795-2.887 5.151-4.8 1.093-1.522 1.942-3.239 2.537-5.092 1.014-3.152.927-5.63.927-5.737a1 1 0 0 0-.38-.751 1.01 1.01 0 0 0-.81-.215c-.088.01-2.088.361-4.732 1.278a31 31 0 0 0-4.322 1.844c-1.659.868-3.103 1.844-4.293 2.907-1.561 1.405-2.917 3.074-3.902 4.83-1.054 1.873-1.65 3.746-1.708 5.434-.01.244.01.488.04.732-1.796-.05-3.767-.235-5.884-.566a53 53 0 0 0 3.19-3.083m4.692 3.006c.05-1.366.556-2.927 1.454-4.517a17.3 17.3 0 0 1 3.493-4.313c1.053-.946 2.35-1.824 3.853-2.614a29.4 29.4 0 0 1 4.03-1.717 34 34 0 0 1 3.21-.937 17.4 17.4 0 0 1-.781 3.805 16.3 16.3 0 0 1-2.254 4.537 15.9 15.9 0 0 1-4.566 4.253c-1.063.664-2.322 1.18-3.727 1.532-1.326.341-2.838.546-4.468.614-.058 0-.107 0-.166.01a2.3 2.3 0 0 1-.078-.653m34.293-4.732a20.9 20.9 0 0 1-4.468 6.634 20.7 20.7 0 0 1-6.634 4.468 20.8 20.8 0 0 1-8.118 1.64 20.9 20.9 0 0 1-8.741-1.913c-.39-.185-.78-.37-1.161-.575.341-.02.703-.059 1.063-.098 1.317-.166 2.693-.459 3.864-.849 1.678-.556 3.132-1.405 4.068-1.99 3.015-1.893 5.317-4.37 6.849-7.376a19 19 0 0 0 1.493-4c.302-1.22.497-2.478.566-3.746.204-3.493.926-4.654 1.668-5.385.663-.644 1.463-.82 1.775-.869.313-.048.596-.039.85-.029.458.01 1.023.02 1.414-.458.283-.342.331-.683.322-.918-.01-.243-.098-.604-.45-.975-.097-.098-.214-.244-.36-.41-.449-.527-1.073-1.258-1.854-1.795-1.22-.839-3.141-1.912-5.424-2.293a11.8 11.8 0 0 0-3.795 0c-1.249.205-2.38.586-3.288 1.122-1.649.966-3.015 1.854-5.63 4.41-2.4 2.351-5.902 6.166-12.497 13.6q-.234.266-.468.517a20.7 20.7 0 0 1-1.142-6.839c0-2.82.556-5.551 1.64-8.117A20.9 20.9 0 0 1 23.08 8.75a20.7 20.7 0 0 1 6.634-4.468 20.8 20.8 0 0 1 8.117-1.64c2.82 0 5.551.557 8.117 1.64a20.9 20.9 0 0 1 6.634 4.468 20.7 20.7 0 0 1 4.468 6.634 20.8 20.8 0 0 1 1.64 8.117c0 2.81-.537 5.551-1.62 8.127'
        ></path>
        <path
          fill='#2F6132'
          d='M42.075 17.587a1.239 1.239 0 1 0 0-2.478 1.239 1.239 0 0 0 0 2.478'
        ></path>
      </svg>
    </div>
  ),
});

let isLoaded = false;

const HoverQuickViewLazyLoad = ({
  newUrlKey,
  className,
  afterSubmit,
}: {
  newUrlKey: string;
  className?: string;
  afterSubmit?: any;
}) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        variant={'outline'}
        className={cn(
          'flex',
          'items-center justify-center',
          'group-hover_opacity-100 lg_opacity-0',
          'relative group-hover_flex',
          'w-full rounded-[10px] border-primary bg-primary font-poppins text-sm font-[600] text-white transition-all',
          className,
        )}
        onClick={() => {
          isLoaded = true;
          setOpen(true);
        }}
      >
        <span className='uppercase'>Choose Options</span>
      </Button>
      {open || isLoaded ? (
        <HoverQuickView
          newUrlKey={newUrlKey}
          afterSubmit={afterSubmit}
          open={open}
          setOpen={setOpen}
        />
      ) : null}
    </>
  );
};

export default HoverQuickViewLazyLoad;
